<template>
  <BaseTableWrapper>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.surveyresults.list.noSurveyresults') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('global.title') }}</th>
            <th>{{$t('views.exaborganizationlead.form.idUserData')}}</th>
            <th>{{$t('views.surveyresults.list.linkToPage')}}</th>
            <th>{{$t('views.surveyresults.list.createdAt')}}</th>
            <th>{{$t('views.surveyresults.list.startedAt')}}</th>
            <th>{{$t('views.surveyresults.list.completedAt')}}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{item.idSurvey.surveyTitle}}</td>
            <td>
              <router-link v-if="item.idUserData && item.idUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idUserData['@id'] }}">
                {{ item.idUserData.name }} {{ item.idUserData.surname }}
              </router-link>
              <router-link v-else-if="item.idUserData" :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
                {{ item.idUserData.firmname1 === '' ? item.idUserData.fullName : item.idUserData.firmname1 }}
              </router-link>
            </td>
            <td>
              <a v-if="item.linkToPage" :href="item.linkToPage" target="_blank">
                {{ item.linkToPage }}
              </a>
            </td>
            <td>
              {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
            </td>
            <td>
              {{ item.startedAt ? $moment(item.startedAt).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </td>
            <td>
              {{ item.completedAt ? $moment(item.completedAt).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </td>
            <td>
              <div class="btn-group">
                <button type="button" class="btn btn-sm btn-link fa fa-eye fa-lg" @click="showItem(item)" v-b-tooltip.hover :title="$t('buttons.show')"></button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'List',
  components: {
    BaseTableWrapper,
    Pagination,
    Loader
  },
  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABSurveysList')
  },
  props: ['item'],
  computed: {
    ...mapGetters({
      error: 'surveyresults/list/error',
      items: 'surveyresults/list/items',
      isLoading: 'surveyresults/list/isLoading',
      view: 'surveyresults/list/view'
    })
  },
  created () {
    this.getPage(addParamsToQuery('e_x_a_b_survey_results', this.searchParams))
  },
  methods: {
    ...mapActions({
      getPage: 'surveyresults/list/getItems'
    }),
    showItem (item) {
      this.$router.push({ name: 'EXABSurveyResultsShow', params: { id: item['@id'] } })
    }
  }
}
</script>

<style scoped>

</style>
